// A shot or the descaling programme cut short by a restart of the machine (checkRestart() of the local app, D-G02 of
// APP-PARITY.md "Detail-Abgleich"): the op group of a newer boot follows one that showed a running shot or a running
// programme. Seen only by an app that saw the machine before the restart, as the local app; a restart command cannot
// interrupt them (catalog pre not_busy), so it was a crash, the power or the watchdog.
import type { GroupEntry } from '@brewcore/app-contract';

export interface Interrupted {
  key: 'shotInterrupted' | 'dsInterrupted';
  /** this device's clock when it was noticed */
  at: number;
}

/** How long the note stays (the local app's toast was gone after seconds; the cloud keeps it a while). */
export const INTERRUPTED_MS = 30 * 60_000;

interface OpData {
  state?: number;
  rinse?: boolean;
  brew?: { active?: boolean };
  descale?: { phase?: number };
}

const running = (op: OpData): Interrupted['key'] | null => {
  const phase = op.descale?.phase ?? 0;
  if (phase > 0 && phase < 7) return 'dsInterrupted';
  if ((op.state === 20 && op.rinse !== true) || op.brew?.active === true) return 'shotInterrupted';
  return null;
};

/** What the new op group says about the previous one: interrupted, or null (nothing to say). */
export function interruptedBy(
  prev: GroupEntry | undefined,
  next: GroupEntry,
  now: number,
): Interrupted | null {
  if (!prev || next.boot <= prev.boot) return null;
  const key = running(prev.data as OpData);
  return key ? { key, at: now } : null;
}

/** A running shot or programme again ends the note, so does its age. */
export function interruptedNow(
  i: Interrupted | null | undefined,
  op: GroupEntry | undefined,
  now: number,
): Interrupted | null {
  if (!i || now - i.at > INTERRUPTED_MS) return null;
  if (op && running(op.data as OpData) !== null) return null;
  return i;
}
